import { getUnitCategoryName } from "verdi-common/i18n";
import { seriesNamesDiffer } from "../format";
import type { PlotLayout } from "./layout/plot-layout";
import type { PreparedSeries } from "./prepare-series";

export function PanelLegend({
    series,
    layout,
    deviceNameOnly = false,
}: {
    series: PreparedSeries[];
    layout: PlotLayout;
    /** Metric pill already names the category — legend only needs the device. */
    deviceNameOnly?: boolean;
}) {
    if (series.length === 0) return null;

    const showDeviceName = seriesNamesDiffer(series);

    return (
        <div
            className={"flex min-w-0 flex-wrap items-center justify-start gap-x-4 gap-y-1.5 pt-2"}
            style={{ marginLeft: layout.gutters.left, marginRight: layout.gutters.right }}
        >
            {series.map((s) => (
                <div key={String(s.streamId)} className={"flex min-w-0 items-center gap-1.5"}>
                    <span
                        aria-hidden
                        className={"inline-block h-1 w-3.5 shrink-0 rounded-full"}
                        style={{ backgroundColor: s.color }}
                    />
                    <div className={"truncate text-xs font-normal text-muted-foreground"}>
                        {deviceNameOnly ? (
                            s.name
                        ) : (
                            <>
                                {getUnitCategoryName(s.unitCategory)}
                                {showDeviceName ? (
                                    <span className={"text-[11px] font-normal text-muted-foreground/80"}>
                                        {" "}
                                        · {s.name}
                                    </span>
                                ) : null}
                            </>
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
}
